import {
  Box,
  Button,
  // Grid,
  makeStyles,
  Modal,
  Paper,
  Typography,
} from "@material-ui/core";
import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
// import { SubItemsDisplay } from "./components/SubItemsDisplay";
import SimpleSubTitle from "./components/SimpleSubTitle";
import SubItemVariation from "./components/SubItemVariation";
const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: "700px",
    height: "100%",
    padding: "10px 10px",
    borderStyle: "none",
    top: "50%",
    left: "50%",
    maxHeight: "600px",
    transform: "translate(-50%,-50%)",
    shadows: "none",
    [theme.breakpoints.between("lm", "lm")]: {
      width: "600px",
      height: "550px",
    },
    [theme.breakpoints.between("auto", "auto")]: {
      width: "500px",
      height: "450px",
    },
  },
  borderBox: {
    width: "100%",
    height: "100%",
    border: "2px solid rgb(151,151,151)",
    borderRadius: "5px",
    padding: "0 10px",
    paddingTop: "40px",
    maxHeight: "inherit",
    overflowY: "auto",
    overflowX: "hidden",
  },
  modalTitle: {
    backgroundColor: "rgb(232,232,232)",
    margin: "0 -10px",
    padding: "10px 0", //for the padding of 10 px in the border box
    paddingLeft: "10px",
    marginBottom: "10px",
  },
  itemBox: {
    width: "auto",
    height: "auto",
    border: "1px solid rgb(232,232,232)",
    borderRadius: "5px",
    boxShadow: "2px 2px 10px 0 rgba(0,0,0, 0.2)",
  },
  img: {
    width: "100%",
  },
  itemTitle: {
    textAlign: "center",
    fontWeight: "bold",
    [theme.breakpoints.between("lm", "lm")]: {
      fontSize: "11px",
    },
    [theme.breakpoints.between("md ", "md ")]: {
      fontSize: "9px",
    },
  },
  modalButton: {
    borderRadius: "25px",
    padding: "5px 24px",
    margin: "0 auto",
    width: "130px",
    display: "block",
    marginTop: "20px",
    marginBottom: "20px",
  },
  simpleBox: {
    marginBottom: "10px",
  },
  spanStatus: {
    color: "red",
  },
}));
export default function ItemModal({
  open,
  handleClose,
  handleOpen,
  subItem,
  title,
  subTitle,
}) {
  const classes = useStyles();
  const subList = subItem;

  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Paper className={classes.paper}>
        <Box className={classes.borderBox}>
          <Typography variant="h2" className={classes.modalTitle}>
            {subTitle}
          </Typography>

          {title === "野菜" ? (
            subList && <SimpleSubTitle itemList={subList} />
          ) : (
            // <Grid container spacing={3}>
            //   {subItem &&
            //     subItem.map((item) => (
            //       <Grid item md={6} xs={12} key={item.id}>
            //         <SubItemsDisplay item={item} />
            //       </Grid>
            //     ))}
            // </Grid>
            <SubItemVariation
              title="常時取り扱い商品"
              subItem={subItem}
              status={false}
            />
          )}
          <Button
            onClick={handleClose}
            className={classes.modalButton}
            variant="contained"
            color="primary"
          >
            閉じる
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
}
